import { OutstandingDebt } from '../models/outstanding-debt';
import { Action } from '@ngrx/store';

export const GET = '[OutstandingDebt] Get';
export const GET_COMPLETE = '[OutstandingDebt] Get Complete';
export const GET_ERROR = '[OutstandingDebt] Get Error';

export class Get implements Action {
  readonly type = GET;
  constructor(public propertyRef: number) { }
}

export class GetComplete implements Action {
  readonly type = GET_COMPLETE;
  constructor(public payload: OutstandingDebt) { }
}

export class GetError implements Action {
  readonly type = GET_ERROR;
  constructor(public payload: any) { }  // why are we using any for errors ?
}

export type Actions =
  Get |
  GetComplete |
  GetError;
